import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceReleaseProjectLimitRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-release-project-limit',
	path: '/jira/settings/system/performance/metrics/release/projectlimit',
};
